<script>
    import './chainModal.css';
    import {wrongChainMessage} from "../../constants/constants";
</script>
<div class="popup flex items-center flex-center">
    <div class="popup-content relative">
        <div class="no-valid-chain">{wrongChainMessage[process.env.SUPPORTED_CHAIN]}</div>
    </div>
</div>
